/* ==========================================================================
   HAPŪ HELPERS — FAQ EXPAND ALL
   --------------------------------------------------------------------------
   Drives the expand all control on hh-faq-rich blocks.

   The questions themselves are native <details>, so they open and close with
   no JavaScript at all. This file only adds the bulk control, which is why the
   button ships hidden in the markup and is revealed here. No JS, no dead
   button.

   The label stays in sync with the actual state, so collapsing one question by
   hand flips the button back to "Expand all" on its own.
   ========================================================================== */

(function () {
  "use strict";

  function init(root) {
    if (root.getAttribute("data-hh-faq-ready") === "true") return;

    var btn = root.querySelector("[data-hh-faq-toggle]");
    var label = root.querySelector("[data-hh-faq-label]");
    var items = Array.prototype.slice.call(root.querySelectorAll(".hh-faq__item"));
    if (!btn || !label || items.length === 0) return;

    root.setAttribute("data-hh-faq-ready", "true");
    btn.hidden = false;

    function allOpen() {
      for (var i = 0; i < items.length; i++) {
        if (!items[i].open) return false;
      }
      return true;
    }

    function sync() {
      var open = allOpen();
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      label.textContent = open
        ? btn.getAttribute("data-label-close")
        : btn.getAttribute("data-label-open");
    }

    btn.addEventListener("click", function () {
      var next = !allOpen();
      for (var i = 0; i < items.length; i++) {
        items[i].open = next;
      }
      sync();
    });

    for (var i = 0; i < items.length; i++) {
      items[i].addEventListener("toggle", sync);
    }

    sync();
  }

  function boot() {
    var blocks = document.querySelectorAll("[data-hh-faq]");
    for (var i = 0; i < blocks.length; i++) init(blocks[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /* Re-run when a section is re-rendered in the theme editor. */
  document.addEventListener("shopify:section:load", boot);
})();